/**
 * Errore leggibile: cosa e successo + come rimediare. Riceve direttamente il corpo
 * dell'API, formato {error:{code, message_it, remedy_it}} (API-CONTRACT §errori).
 * Il code serve a chi fa assistenza, non a lei: resta in un attributo, non nel testo.
 */
import type { ApiError } from '@mamma/contracts'

export type { ApiError }

export type ErrorMessageProps = {
  error: ApiError
  retryLabel?: string
  onRetry?: () => void
}

export function ErrorMessage({ error, retryLabel = 'Riprova', onRetry }: ErrorMessageProps) {
  return (
    <div
      role="alert"
      data-error-code={error.code}
      className="rounded-field border-2 border-error bg-surface px-[20px] py-[16px] text-ink"
    >
      <p className="text-body">
        <strong>Cosa è successo: </strong>
        {error.message_it}
      </p>
      <p className="mt-2 text-body">
        <strong>Come rimediare: </strong>
        {error.remedy_it}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 min-h-control w-full rounded-control border-2 border-ink bg-surface px-3 text-secondary text-ink"
        >
          {retryLabel}
        </button>
      )}
    </div>
  )
}
